<div class="modal-close" (click)="closeDrawer()">
  <i class="feather x"></i>
</div>
<!-- <div class="company-name-wrapper">
  <div class="company-name">{{ company?.name }}</div>
</div> -->
<ng-container #viewContainerRef></ng-container>
